import { render } from "./windBalise.vue?vue&type=template&id=047467fe"
import script from "./windBalise.vue?vue&type=script&lang=js"
export * from "./windBalise.vue?vue&type=script&lang=js"

import "./windBalise.vue?vue&type=style&index=0&id=047467fe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__